export const FETCH_WEEKLY_SUMMARIES_BEGIN = 'FETCH_WEEKLY_SUMMARIES_BEGIN';
export const FETCH_WEEKLY_SUMMARIES_SUCCESS = 'FETCH_WEEKLY_SUMMARIES_SUCCESS';
export const FETCH_WEEKLY_SUMMARIES_ERROR = 'FETCH_WEEKLY_SUMMARIES_ERROR';
